import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import useUiContext from '@/custolink-hooks/useUiContext'
import {
  AssetFrontendVoiceCallsApi,
  AssetFrontendVoiceCallsApi$InfoState,
  type PublicAssetFrontendApi$AssetComponentDto,
} from '@/custolink-transpiled_by_server/bc.asset_interaction.api_methods'

export type VoiceCallMode = 'initial' | 'instant_call' | 'show_text'

/**
 * The voice-call decision, lifted from `BottomSection`'s `useVoiceCallPreHook`.
 * When the organisation configures a direct phone number the incumbent dials it
 * immediately; otherwise it opens the in-app voice component. The three worlds
 * must keep that behaviour, so they all read it from here.
 */
export default function useVoiceCallMode(component: PublicAssetFrontendApi$AssetComponentDto | null) {
  const uic = useUiContext()
  const [mode, setMode] = useState<VoiceCallMode>('initial')

  const req = useQuery({
    queryFn: () => AssetFrontendVoiceCallsApi.getInfo(uic._orgId, component!.id),
    queryKey: ['AssetFrontendVoiceCallsApi.getInfo', uic._orgId, component?.id],
    enabled: component != null,
  })

  useEffect(() => {
    if (req.data != null) {
      if (req.data.state === AssetFrontendVoiceCallsApi$InfoState.CallPhoneNumber) {
        setMode('instant_call')
      } else if (req.data.state === AssetFrontendVoiceCallsApi$InfoState.ShowText) {
        setMode('show_text')
      }
    }
  }, [req.data])

  return {
    mode,
    phone: req.data?.phone ?? '',
  }
}
